import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";

export interface ReportsState {
  downloadingState: LoadingState;
  errorMessage?: string;
}
export const initialReportsState: ReportsState = {
  downloadingState: LoadingState.idle,
};
